type Target = HTMLElement | Document | Window

function on<K extends keyof HTMLElementEventMap>(
  target: Target, type: K, handler: (e: HTMLElementEventMap[K]) => void,
) {
  target.addEventListener(type, handler as EventListener)
  return () => {
    target.removeEventListener(type, handler as EventListener)
  }
}

function off<K extends keyof HTMLElementEventMap>(
  target: Target, type: K, handler: (e: HTMLElementEventMap[K]) => void,
) {
  target.removeEventListener(type, handler as EventListener)
}

function once<K extends keyof HTMLElementEventMap>(
  target: Target, type: K, handler: (e: HTMLElementEventMap[K]) => void,
) {
  const removeHandler = on(target, type, (e) => {
    removeHandler()
    handler(e)
  })
  return removeHandler
}

// https://qiita.com/simiraaaa/items/2e7478d72f365aa48356
function execCopy(string: string, html = false) {
  const temp = document.createElement('div');

  if (html) {
    temp.appendChild(document.createElement('pre')).innerHTML = string;
  } else {
    temp.appendChild(document.createElement('pre')).textContent = string;
  }

  const s = temp.style;
  s.position = 'fixed';
  s.left = '-100%';

  document.body.appendChild(temp);
  const selection = document.getSelection()
  if (selection) {
    selection.selectAllChildren(temp);
    const result = document.execCommand('copy');

    document.body.removeChild(temp);
    // true なら実行できている falseなら失敗か対応していないか
    return result;
  }

}
const pbcopy = execCopy

export const dom = {
  on, off, once, pbcopy,
}
